import catalogos from "./catalogos/pj";
import sistema from "./sistema/pj";

const pj = {
  catalogos: catalogos,
  sistema: sistema
}

export default pj



//////////////////
// WEBPACK FOOTER
// ./static/js/api/PJ/pjapi.js
// module id = null
// module chunks = 